import { AccountEntity } from '../accountConfig/accountConfig.interface';
import { GiftDeliveryForAdmin } from '../giftDelivery/giftDelivery.interface';

export enum GiftSettlementStatus {
  Draft = 'Draft',
  Paid = 'Paid',
}

export enum GiftSettlementMethod {
  FeeRate = 'FeeRate',
  Rebate = 'Rebate',
}

/** 정산 예정 금액 프리뷰 (백엔드 계산) */
export interface GiftSettlementLinePreview {
  quantity: number;
  unitAmount: number;
  surcharge: number;
  lineAmount: number;
  hasSettlementInfo: boolean;
}

/** 정산 예정 배송 항목 */
export interface SettlementPendingEntry {
  delivery: GiftDeliveryForAdmin;
  preview: GiftSettlementLinePreview;
}

/** 업체정산 상품 스냅샷 */
export interface GiftSupplyItemSnapshot {
  giftItemInfo?: string | { _id: string; name: string };
  giftItemBrand?: string | { _id: string; name: string };
  name?: string;
  brandName?: string;
  productCode?: string;
  priceRegular?: number;
  priceRetail?: number;
  priceWhole?: number;
}

/** 업체정산 라인 */
export interface GiftSupplySettlementLine {
  giftDelivery?: string | GiftDeliveryForAdmin;
  giftCoupon?: string;
  item: GiftSupplyItemSnapshot;
  quantity: number;
  unitAmount: number;
  surcharge: number;
  lineAmount: number;
  note?: string;
}

/** 업체정산 문서 */
export interface GiftSupplySettlement {
  _id: string;
  giftItemBrand:
    | string
    | {
        _id: string;
        name: string;
        settlementInfo?: {
          accountEntity?: AccountEntity;
          shippingFee?: number;
          freeShippingMinQuantity?: number;
          courierFee?: number;
          courierFreeMinQuantity?: number;
          settlementDay?: number;
        };
      };
  year: number;
  month: number;
  status: GiftSettlementStatus;
  lines: GiftSupplySettlementLine[];
  totalAmount: number;
  executedAt?: Date;
  memo?: string;
  createdAt: Date;
  updatedAt: Date;
}

/** POST /admin/gift-supply-settlement/settle body */
export interface GiftSupplySettleBody {
  year?: number;
  month?: number;
  target: { giftItemBrand: string };
  giftDeliveryIds: string[];
  status?: GiftSettlementStatus;
  memo?: string;
}

/** POST settle 응답 */
export interface GiftSupplySettleResult {
  settlement: GiftSupplySettlement;
  includedCount: number;
  skipped: {
    giftDeliveryId: string;
    reason: 'notFound' | 'brandMismatch' | 'alreadySettled' | 'notDelivered';
  }[];
}

/** PATCH body */
export interface GiftSupplySettlementPatchBody {
  year?: number;
  month?: number;
  status?: GiftSettlementStatus;
  /**
   * 지급 집행일(ISO 문자열). status=Paid 와 함께 보내면 해당 일자로 기록되고,
   * 생략하면 백엔드가 집행 시각(now)으로 자동 세팅한다. Draft 전환 시엔 백엔드가 비운다.
   */
  executedAt?: string;
  memo?: string;
  addDeliveryIds?: string[];
  removeDeliveryIds?: string[];
}
